import styled from 'styled-components'

export default styled.div`
  flex: 1 1 auto;
  -ms-flexbox: 1 1 auto;
`
